export default {
    updateTotalPage(state, payload) {
        state.TotalInfo = payload;
    },
    updateProduct(state, payload) {
        state.Product = payload;
    },
    updateProducts(state, payload) {
        state.Products = payload;
    }
}